export const LOCATION_OPTIONS = ["Bodø", "Evenes", "Tromsø", "Værnes"];

function toIsoDate(value) {
  return value.toISOString().split("T")[0];
}

export function isValidRegNum(value) {
  return typeof value === "string" && value.length === 7 && /^[A-Z]{2}[0-9]{5}$/.test(value);
}

export function buildReturnDraft(now = new Date()) {
  return {
    type: "return",
    step: 1,
    basicInfo: {
      regNum: "",
      vehicleType: "Personbil",
      brand: "",
      model: "",
      mileage: "",
      location: "",
    },
    checklist: {
      tollTag: true,
      spareKey: true,
      twoTireSets: true,
      shelf: true,
      cableType2: true,
      emergencyCharger: true,
      tank: true,
    },
    returnInfo: {
      date: toIsoDate(now),
      notes: "",
      by: "",
    },
    damages: [],
    focalx: null,
    focalxPending: null,
    processing: {
      autoplanDone: false,
      autofleksDone: false,
    },
    returnProcessing: {
      autofleksChecked: false,
      autoplanChecked: false,
      state: "active",
      holdAfterReopen: false,
    },
    created: now.toISOString(),
  };
}

export function buildReceptionDraft(now = new Date()) {
  return {
    type: "reception",
    step: 1,
    basicInfo: {
      regNum: "",
      date: toIsoDate(now),
      mileage: "",
      by: "",
      location: "",
    },
    checklist: {
      tollTag: true,
      rubberMats: true,
      fullTank: true,
      shelf: true,
      cableType2: true,
      twoTireSets: true,
      noDamage: true,
    },
    notes: "",
    damages: [],
    created: now.toISOString(),
  };
}

export function hydrateRecordForFlow(record) {
  const source = record || {};
  const template =
    source.type === "return" ? buildReturnDraft() : buildReceptionDraft();

  const hydrated = {
    ...template,
    ...source,
    step: 1,
    basicInfo: {
      ...template.basicInfo,
      ...(source.basicInfo || {}),
    },
    checklist: {
      ...template.checklist,
      ...(source.checklist || {}),
    },
    damages: Array.isArray(source.damages) ? source.damages : [],
    created: source.created || template.created,
  };

  if (source.type === "return") {
    hydrated.returnInfo = {
      ...template.returnInfo,
      ...(source.returnInfo || {}),
    };
    hydrated.focalx = source.focalx ?? null;
    hydrated.focalxPending = source.focalxPending ?? null;
    hydrated.processing = {
      ...template.processing,
      ...(source.processing || {}),
    };
    const legacyAutoplanDone = hydrated.processing.autoplanDone === true;
    const legacyAutofleksDone = hydrated.processing.autofleksDone === true;
    const existingReturnProcessing =
      source.returnProcessing && typeof source.returnProcessing === "object"
        ? source.returnProcessing
        : {};
    const autoplanChecked =
      existingReturnProcessing.autoplanChecked === true || legacyAutoplanDone;
    const autofleksChecked =
      existingReturnProcessing.autofleksChecked === true || legacyAutofleksDone;
    hydrated.returnProcessing = {
      ...template.returnProcessing,
      ...existingReturnProcessing,
      autoplanChecked,
      autofleksChecked,
      state:
        existingReturnProcessing.state === "processed" ||
        (autoplanChecked && autofleksChecked)
          ? "processed"
          : "active",
    };
  } else {
    hydrated.notes = source.notes ?? "";
  }

  return hydrated;
}
